import interceptedAxios from '../../../utils/interceptedAxios'
import { z } from 'zod'

const ZApiSuccessResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.string(),
  error_message: z.optional(z.string())
})

export type ApiSuccessResponse = z.infer<typeof ZApiSuccessResponse>

export async function getHSMRegularKekHsmList (
  page: number,
  size: number,
  sortdir: string,
  sortfield: string,
  input: string,
  onSuccess: (requestId: string, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  let field = sortfield
  if (field === 'created At') {
    field = 'createdAt'
  } else if (field === 'created By') {
    field = 'createdBy'
  }
  const url = `/app-config-service/api/v1/crypto/hsm-kek-async?page=${page}&size=${size}&sort=${field},${sortdir}&input=${input}`
  interceptedAxios
    .get(url)
    .then((response) => {
      const parseResponse = ZApiSuccessResponse.safeParse(response.data)
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
